/* Node modules */
import React from 'react';
import { connect } from 'react-redux';
import { getInterlocutorsByCustomer } from '../webAPI/employeeService';

/* Components */
import Confirmation from './Confirmation';

const mapStateToProps = (state, ownProps) => {
	const { protocol, domain } = require('Config');
	const { projectId, estimateNumber } = ownProps.params;
	return {
		user: state.user,
		projectId,
		estimateNumber,
		planLink:
			protocol +
			domain +
			'/ws/G1R0C0/master-key-system/get-plan?project_id=' +
			encodeURIComponent(projectId) +
			'&estimate_number=' +
			estimateNumber
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);



// WEBPACK FOOTER //
// ./src/js/confirmation/ConfirmationContainer.js